export const IMAGE_PLUGIN_KEY = 'image';
export const IMAGE_TYPE = 'image';
